<template>
	<div id="app">
		<div class="pc">
			<div class="code" style="">
				<img src="./image/shouye_saoyisao@2x.png" style="width: 184px;height: 230px;" />
			</div>
			<div class="header">
				<div class="content header-box">
					<div class="logo">
						<img src="./image/header-logo.png" />
						<div class="text">淘速取</div>
					</div>
					<div class="nav">
						<a :class="'nav-item ' +  (navIndex == index?'nav-item-choose':'') " @click="jumpNav(index)" v-for="(item,index) in navList"
						 :key='index'>{{item}}</a>
					</div>
				</div>
			</div>
			<div style="height: 128px;width: 100%;"></div>
			<div class="banner" :style="navIndex == 2?'background-color: #2B27CF;':''">
				<div v-if="navIndex == 2" class="content banner-box">
					<img src="./image/zhaoshang_banner@2x.png" />
				</div>
				<swiper v-else class="content banner-box" ref="mySwiper" :options="swiperOptions">
					<swiper-slide>
						<img src="./image/banner1.png" />
					</swiper-slide>
					<swiper-slide>
						<img src="./image/banner2.png" />
					</swiper-slide>
					<div class="swiper-pagination" slot="pagination"></div>
				</swiper>
			</div>
			<transition name="fade" mode="out-in">
				<router-view />
			</transition>

			<div class="footer">
				<div class="content footer-box">
					<div class="text">Copyright©2020 www.taosuqu.cn AII Rights Reserved.淘速取开发组</div>
					<a class="text" href="https://beian.miit.gov.cn/" target="_blank">备案号：浙ICP备2020041218号-1</a>
				</div>
			</div>
		</div>

		<div class="mobile">
			<img src="./image/index1.png" style="width: 100%;" />
			<div style="width: 100%;display: flex;justify-content: space-around;margin-bottom: 30px;">
				<img src="./image/index-btn-1.png" @click='onDownload($event, "ios")' style="width: 164px;height: 55px;" />
				<img src="./image/index-btn-2.png" @click='onDownload($event, "android")' style="width: 164px;height: 55px;" />
			</div>
			<img src="./image/index2.png" style="width: 100%;" />
			<img src="./image/index3.png" style="width: 100%;" />
			<img src="./image/index4.png" style="width: 100%;" />
			<!-- <img src="./image/index.jpg" style="width: 100%;" /> -->
		</div>

	</div>
</template>

<script>
	import {
		Swiper,
		SwiperSlide,
		directive
	} from 'vue-awesome-swiper'
	import 'swiper/swiper-bundle.css'

	import SwiperCore, {
		// 使用swiper6的模组扩展
		Autoplay,
		Navigation
	} from 'swiper';
	SwiperCore.use([Navigation, Autoplay]);

	export default {
		name: 'app',
		data() {
			return {
				navList: ['首页', '关于淘速取', '招商加盟', '联系我们'],
				navIndex: 0,
				swiperOptions: {
					autoplay: {
						disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
						delay: 5000, // 自动切换的时间间隔（单位ms）
					},
					initialSlide: 0,
					loop: true,
					pagination: {
						el: '.swiper-pagination',
						clickable: true
					}, // 分页按钮
					paginationClickable: true,
					// Some Swiper option/callback...
				}
			}
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.$swiper
			}
		},
		mounted() {
			// this.swiper.slideTo(3, 1000, true)
		},
		components: {
			Swiper,
			SwiperSlide,
		},
		// directives: {
		// 	swiper: directive
		// },

		methods: {
			jumpNav(index) {
				this.navIndex = index
				let name
				console.log(this.navIndex)
				switch (index) {
					case 0:
						name = "index"
						break;
					case 1:
						name = "about"
						break;
					case 2:
						name = "merchants"
						break;
					case 3:
						name = "join"
						break;
					default:
						break;
				}
				this.$router.push({
					name: name
				})
			},
			onDownload: function(e, args) {
				if (args == 'ios') {
					location.href = "https://apps.apple.com/cn/app/id1528286350";
				} else if (args == 'android') {
					location.href = "https://sj.qq.com/myapp/detail.htm?apkName=taosuqu.wooxin.cn"
				}
			}
		}
	}
</script>

<style lang="less">
	// @import 'swiper/dist/css/swiper.css'

	@media screen and (max-width: 750px) {
		.pc {
			display: none;
		}
	}

	@media screen and (min-width: 750px) {
		.mobile {
			display: none;
		}
	}
	
	.code {
		position: fixed;
		left: 50px;
		// right: 0px;
		top: 200px;
		// margin: 0 auto;
		// width: 100px;
		// transform: translateX(-700px);
		z-index: 999;
	}



	html,
	body {
		width: 100%;
		height: 100%;
		margin: 0;
		padding: 0;
		font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
			"Microsoft YaHei", "微软雅黑", Arial, sans-serif;
	}

	.header {
		width: 100%;
		height: 128px;
		position: fixed;
		top: 0rpx;
		background-color: #FFFFFF;
		border-bottom: #f6f6f6 2px solid;
		z-index: 99;

		.header-box {
			display: flex;
			justify-content: space-between;

			.logo {
				display: flex;
				align-items: center;

				img {
					width: 100px;
					height: 100px;
					display: block;
				}

				.text {
					color: #F03E2E;
					font-size: 32px;
					margin-left: 20px;
				}
			}

			.nav {
				width: 700px;
				background-color: #FFFFFF;
				display: flex;
				justify-content: space-between;

				.nav-item {
					flex: 1;
					text-align: center;
					line-height: 128px;
				}

				.nav-item-choose {
					color: #F03E2E;
					font-weight: bold;
					border-bottom: 4px solid #FF7146;
				}
			}
		}
	}

	.banner {
		width: 100%;
		height: 600px;
		background-color: #F03E2E;
		// overflow: hidden;

		.banner-box {
			height: 100%;
			width: 1200px;
			// background-color: #000066;

			img {
				display: block;
				width: 100%;
				height: 100%;
			}
		}
	}

	.footer {
		width: 100%;
		height: 128px;
		background-color: #34323D;
		text-align: center;

		.footer-box {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
		}

		.text {
			font-size: 18px;
			font-weight: bold;
			color: #FFFFFF;
		}

		.text:nth-child(2) {
			font-size: 14px;
			margin-top: 12px;
			text-decoration: none;
		}
	}
</style>
